// removed by extract-text-webpack-plugin
module.exports = {"Contact":"src-components-Contact----Contact-module---Contact---1kHFP","content":"src-components-Contact----Contact-module---content---jChpK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/Contact.module.css
// module id = 353
// module chunks = 70144966829960